import { render } from "./app-header-navigation-item.vue?vue&type=template&id=bae8e492&scoped=true"
import script from "./app-header-navigation-item.vue?vue&type=script&lang=js"
export * from "./app-header-navigation-item.vue?vue&type=script&lang=js"

import "./app-header-navigation-item.vue?vue&type=style&index=0&id=bae8e492&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bae8e492"]])

export default __exports__